import React from "react";
import './headers.scss'
import {NavLink} from "react-router-dom";
import {toggleClass} from "../../common";

export default function Headers(props) {
    function toggleDropDown(e) {
        let el = e.target;
        let dropdownEl = el.nextElementSibling;
        toggleClass(dropdownEl,'d-none');

    }
    return (
        <nav className="mb-4 navbar navbar-expand-lg  bg-unique">
            <NavLink className="navbar-brand" to='/'>IE Analytics</NavLink>
            <button className="navbar-toggler" type="button" data-toggle="collapse"
                    data-target="#navbarSupportedContent-3"
                    aria-controls="navbarSupportedContent-3" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent-3">
                <ul className="navbar-nav mr-auto">
                    <li className="nav-item">
                        <button className='navbar-dropdown' onClick={toggleDropDown}>Financial Express Editor</button>
                        <div className='card dropdown-card d-none'>
                            <div className='card-columns d-flex'>
                                <div className='card'>
                                    <div className='card-header'>Channels</div>
                                    <div className='card-body'>
                                        Financial Express
                                    </div>
                                </div>
                                <div className='card'>
                                    <div className='card-header'>Channels Permissions</div>
                                    <div className='card-body'>Financial Express (Super Admin)</div>
                                </div>
                            </div>

                        </div>
                    </li>
                    <li className="nav-item">

                    </li>
                    <li className="nav-item">

                    </li>
                </ul>
                <ul className="navbar-nav ml-auto nav-flex-icons">

                    <li className="nav-item dropdown">
                    <span className="nav-link dropdown-toggle waves-effect waves-light" id="navbarDropdownMenuLink"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i
                        className="fa fa-user"></i>
                    </span>
                        <div className="dropdown-menu dropdown-menu-right dropdown-unique"
                             aria-labelledby="navbarDropdownMenuLink">
                            <NavLink className="dropdown-item waves-effect waves-light" to='/home'>Action</NavLink>
                            <NavLink className="dropdown-item waves-effect waves-light" to='/home'>Another
                                action</NavLink>
                            <NavLink className="dropdown-item waves-effect waves-light" to='/home'>Something else
                                here</NavLink>
                        </div>
                    </li>
                </ul>
            </div>
        </nav>
    )
}